export const environment = {
  production: true
};



// WEBPACK FOOTER //
// /home/shane/workspace/website/website-client/src/environments/environment.ts